import {POST} from "@/services/gateway";

const listSnapshotDetails = ({objectType, status, searchTerm, snapshotId, includeEmptyObjects = false, pagination}) => {
  return POST('salesforce/search', {objectType, status, searchTerm, snapshotId, includeEmptyObjects, pagination})
}

const listBreadcrumps = ({userId, folderId}) => {
  return POST('salesforce/breadcrumbs', {userId, folderId})
}


export {
  listSnapshotDetails,
  listBreadcrumps
}
